"use strict";

import React from "react"; // eslint-disable-line no-unused-vars
import ReactDOM from "react-dom";
import { browserHistory } from "react-router";
import { syncHistoryWithStore } from "react-router-redux";
import { AppContainer } from "react-hot-loader";
import configureStore from "./store";
import routes from "./routes";
import Root from "./root";

require("../images/mapPin-primary.png");
require("../images/mapPin-secondary.png");

let store;
let history;

export default function configureClient(initialState, element = "app") {
  store = configureStore(initialState);
  history = syncHistoryWithStore(browserHistory, store);

  ReactDOM.hydrate(
    <AppContainer>
      <Root
        store={store}
        history={history}
        routes={routes}
      />
    </AppContainer>
    , document.getElementById(element)
  );

  document.body.className += " is-ready";
}



// WEBPACK FOOTER //
// ./assets/shared/client.jsx